export const utf8ToBase64 = (value: string): string => window.btoa(encodeURIComponent(value));

export const base64ToUtf8 = (value: string): string => {
  return decodeURIComponent(window.atob(value));
};

export const getInitials = (value: string): string => {
  if (!value.trim()) return '';

  const words = value.trim().split(/\s+/);

  const initials = words
    .map(word => {
      const firstLetter = word.match(/[A-Za-z]/);
      return firstLetter ? firstLetter[0].toUpperCase() : '';
    })
    .join('');

  return initials;
};
